// flow weak
import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
class EditCompetitionExpense extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };
  constructor(props) {
    super(props);
    this.state = {
      status_types: [],
      id:props.match.params.id,
      expense_types: [],
      buddy_search_list:[],
      purposes:[],
      expense_details: {
        id:props.match.params.id,
        purpose: '',
        item: '',
        quantity:0,
        size:'',
        amount:0,
        bill:'',
        status:1,
        paid_by:'',
        paid_on_date:moment(),
        expense_type:10,
        mobile_no:'',
      },
      data_uploaded: false,
      data_error: false,
      addExpenseView:false,
      searched:false,
    };
    this.getExpenseDetail = this.getExpenseDetail.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilebill = this.handleFilebill.bind(this);
    this.getCompetitionExpenseInputs = this.getCompetitionExpenseInputs.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
  }
  componentDidMount() {
    console.log('EditCompetitionExpense')
    this.getCompetitionExpenseInputs();
    this.getExpenseDetail();
    console.log(this.state);
  }
  getCompetitionExpenseInputs() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_competition_expense/`;
     const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({status_types: data.status_types,expense_types: data.expense_types,purposes:data.purposes});
        })
       .catch(error => error);
  }
  getExpenseDetail(){
    const url = `${getLocationOrigin()}/tournament/get_competition_expense_details/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'id': this.state.id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({expense_details: data.expense_detail, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  getSearchList() {
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': this.state.expense_details.mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true,searched :true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  setSearch(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.expense_details);
        new_selected_one['paid_by'] = [buddy_id,name]
        new_selected_one['new_paid_by'] = buddy_id
        new_selected_one['paid_by_name'] = name
        this.setState({expense_details: new_selected_one, search: false,searched:false});
    }
  postSaveExpense(data, props) {
    console.log(data);
    if(!data['new_bill']){data['new_bill'] = ''}
    if(!data['new_paid_by']){data['new_paid_by'] = ''}
    if(data['new_paid_on_date'])
        {data['new_paid_on_date'] = moment(data['new_paid_on_date'])}
    else{data['new_paid_on_date'] = ''}
    console.log('postSaveExpense')
    const url = `${getLocationOrigin()}/tournament/save_expense_details/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                             'id': data.id,
                             'purpose':data.purpose,
                             'item':data.item,
                             'quantity':data.quantity,
                             'size':data.size,
                             'amount':data.amount,
                             'status':data.status,
                             'expense_type':data.expense_type,
                             'new_paid_on_date':data.new_paid_on_date,
                             'new_bill':data.new_bill,
                             'new_paid_by':data.new_paid_by,
                           });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) =>{                      // first then()
          alert(response.message);
          this.setState({addExpenseView:false})
          this.props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.expense_details);
    new_selected_one[name] = event.target.value
    this.setState({expense_details: new_selected_one});
  }
  handleDateChange(date){
    var new_selected_one =  Object.assign({}, this.state.expense_details);
    new_selected_one['new_paid_on_date'] = date
    new_selected_one['paid_on_date'] = date
    this.setState({expense_details: new_selected_one});
  }
  handleSubmit(event) {
    event.preventDefault();
    this.postSaveExpense(this.state.expense_details, this.props);
    console.log('post');
    console.log(this.state);
  }
  toAddExpense(){
    this.props.history.goBack();
  }
  handleFilebill(selectorFiles          ){
    var new_selected_one =  Object.assign({}, this.state.expense_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['new_bill'] = selectorFiles[0]
    this.setState({expense_details: new_selected_one});
  }
  render() {
    console.log(this.state)
    return(
      <div className="col-md-12" style={styles.container}>
        <div className="col-md-8 table_container1">
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Competition Expense</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Purpose
              </div>
              <div className="col-md-6 input-group">
                <select name="purpose" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.purposes.map((purpose, index) => (
                        <option key={purpose[0]} selected={this.state.expense_details && purpose[0] == this.state.expense_details.purpose && purpose[1]} value={purpose[0]}>{purpose[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Item
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="item" className="required" value={this.state.expense_details.item}
                   onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Quantity
              </div>
              <div className="col-md-6 input-group">
                <input type="number" style={styles.input} name="quantity" className="required" value={this.state.expense_details.quantity}
                   onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Size
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="size" className="required" value={this.state.expense_details.size}
                   onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount
              </div>
              <div className="col-md-6 input-group">
                <input type="number" style={styles.input} name="amount" className="required" value={this.state.expense_details.amount}
                   onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Type
              </div>
              <div className="col-md-6 input-group">
                <select name="expense_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.expense_types.map((expense_type, index) => (
                        <option key={index} selected={expense_type[0] == this.state.expense_details.expense_type && expense_type[1]} value={expense_type[0]} >{ expense_type[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Status
              </div>
              <div className="col-md-6 input-group">
                <select name="status" className="col-md-6" style={styles.item_body} value={this.state.value}
                      onChange={this.handleChange}>
                      {
                        this.state.status_types.map((status, index) => (
                        <option key={index} selected={status[0] == this.state.expense_details.status && status[1]} value={status[0]} >{ status[1]}</option>
                        ))
                      }
                    </select>
              </div>
            </div>
            {this.state.expense_details && this.state.expense_details.status == 1 &&
              <div>
            {this.state.expense_details.paid_by != '' &&
            <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    Paid By
                </div>
                <div  className="col-md-5">
                {this.state.expense_details.paid_by[1]}
                  </div>
            </div>
            }
            <div style={styles.items} className="col-md-12" >
                        <div style={styles.item_header} className="col-md-6">
                            {this.state.expense_details.paid_by ? "Edit Payer":"Search Payer" }
                        </div>
                        <div className="col-md-6 input-group">
                                <input type="text" name="mobile_no" className="col-md-8"
                                placeholder="Paid By .." value={this.state.mobile_no} onChange={(e) =>{this.handleChange(e)}}/>
                                <div className="col-md-1">
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                                </div>
                         </div>
                    </div>
                        {this.state.searched && this.state.search?
                            <div className="col-md-12 btn-group">
                                { this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                        </div>
                    }</div>:''}
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Paid on Date
              </div>
              <div className="col-md-6 input-group">
                <DatePicker name="paid_on_date"  selected={this.state.expense_details.paid_on_date ? moment(this.state.expense_details.paid_on_date) :this.state.expense_details.paid_on_date} onChange={this.handleDateChange}/>
              </div>
            </div>
            {this.state.expense_details.bill &&
            <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Bill
                        </div>
                    <img id="bill" src={this.state.expense_details.bill } alt="Bill"/>
            </div>
            }
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                {this.state.expense_details.bill ? "Change Bill":"Upload Bill"}
              </div>
              <div className="col-md-6 input-group">
                  <input type="file" style={styles.input} name="new_bill" onChange={ (e) => this.handleFilebill(e.target.files) }/>
              </div>
            </div>
            </div>
          }
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
              <input className="button1" type="button" value="Cancel" style={{backgroundColor:'red',color:'#ffffff',marginLeft:'20px'}} onClick={() => {this.toAddExpense()}} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default EditCompetitionExpense;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editCompetitionExpense/index.js